import Seo from "@/components/feature/Seo";
import HeroCarousel from "./components/HeroCarousel";
import CategoryEntry from "./components/CategoryEntry";
import LatestUpdates from "./components/LatestUpdates";
import PopularRank from "./components/PopularRank";
import Specials from "./components/Specials";

const features = [
  {
    icon: "ri-book-read-line",
    title: "海量韩漫资源",
    desc: "聚合爱情、奇幻、动作等七大题材，持续更新最新连载章节。",
  },
  {
    icon: "ri-search-eye-line",
    title: "精准分类搜索",
    desc: "支持题材、状态多维度筛选与关键词模糊搜索，秒速找到想看的作品。",
  },
  {
    icon: "ri-heart-add-line",
    title: "免费畅读体验",
    desc: "无需付费注册即可在线阅读，收藏、阅读偏好自动保存在本地。",
  },
];

export default function Home() {
  return (
    <>
      <Seo
        title="韩漫免费观看在线阅读漫画 - 最新韩漫漫画全集平台"
        description="韩漫免费观看在线阅读漫画网站，汇聚丰富韩漫资源，涵盖爱情、奇幻、动作等多个题材，支持在线浏览最新更新章节，让您轻松体验精彩漫画内容。"
        keywords="韩漫,免费观看,在线阅读,漫画,韩漫漫画,韩漫全集,最新韩漫,漫画平台"
      />

      <div className="mx-auto w-full max-w-7xl px-4 py-6 md:px-6 md:py-8">
        <div className="mb-6 text-center md:mb-8">
          <h1 className="font-display text-2xl font-extrabold tracking-tight text-foreground-950 md:text-4xl">
            韩漫免费观看在线阅读漫画
          </h1>
          <p className="mx-auto mt-3 max-w-3xl text-sm leading-relaxed text-foreground-600 md:text-base">
            汇聚丰富韩漫资源，涵盖爱情、奇幻、动作等多个题材，支持在线浏览最新更新章节，让您轻松体验精彩漫画内容。
          </p>
          <div className="mt-5 flex flex-wrap items-center justify-center gap-x-8 gap-y-3 text-sm">
            <span className="flex items-center gap-2 text-foreground-700">
              <i className="ri-book-2-line text-primary-600" />
              <strong className="font-semibold text-foreground-950">1251</strong> 部作品
            </span>
            <span className="flex items-center gap-2 text-foreground-700">
              <i className="ri-flashlight-line text-primary-600" />
              <strong className="font-semibold text-foreground-950">每日</strong> 更新连载
            </span>
            <span className="flex items-center gap-2 text-foreground-700">
              <i className="ri-wallet-3-line text-primary-600" />
              <strong className="font-semibold text-foreground-950">0 元</strong> 免费畅读
            </span>
          </div>
        </div>

        <div className="space-y-10 md:space-y-14">
          <HeroCarousel />

          <CategoryEntry />

          <div className="grid grid-cols-1 gap-5 lg:grid-cols-3">
            <div className="lg:col-span-2">
              <LatestUpdates />
            </div>
            <div className="lg:col-span-1">
              <PopularRank />
            </div>
          </div>

          <Specials />

          <section className="grid grid-cols-1 gap-4 md:grid-cols-3">
            {features.map((f) => (
              <div
                key={f.title}
                className="rounded-lg border border-background-200 bg-background-100 p-5"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                  <i className={`${f.icon} text-xl`} />
                </span>
                <h3 className="mt-3 text-base font-semibold text-foreground-950">
                  {f.title}
                </h3>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">
                  {f.desc}
                </p>
              </div>
            ))}
          </section>
        </div>
      </div>
    </>
  );
}